import { render, staticRenderFns } from "./WorkAndBuhin.vue?vue&type=template&id=5c944a52&scoped=true&"
import script from "./WorkAndBuhin.vue?vue&type=script&lang=ts&"
export * from "./WorkAndBuhin.vue?vue&type=script&lang=ts&"
import style0 from "./WorkAndBuhin.vue?vue&type=style&index=0&id=5c944a52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c944a52",
  null
  
)

export default component.exports